var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoFortunaSimple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 42.604,
    viewBox: "0 0 160 42.604",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1503",
    "data-name": "Group 1503",
    transform: "translate(13808.2 -15850.8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2184",
    "data-name": "Rectangle 2184",
    width: 160,
    height: 42.604,
    transform: "translate(-13808.2 15850.8)",
    fill: "#ffdb01"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4218",
    "data-name": "Path 4218",
    d: "M509.5,170.324V153.9h13.062v4.079h-8.874v2.2h6.889v4.079h-6.889v6.063Z",
    transform: "translate(-14304.638 15709.962)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4219",
    "data-name": "Path 4219",
    d: "M587.134,160.955h4.189a1.572,1.572,0,0,0,1.709-1.488,1.51,1.51,0,0,0-1.709-1.488h-4.189v2.976M583,170.324V153.9h8.763a5.4,5.4,0,0,1,5.512,5.567,5.28,5.28,0,0,1-3.252,4.905c.386.661,3.2,5.456,3.527,6.008H592.37c-.276-.5-2.7-4.8-3.086-5.4h-2.15v5.4H583Z",
    transform: "translate(-14337.628 15709.962)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4220",
    "data-name": "Path 4220",
    d: "M621.923,170.324V157.979H617.9V153.9h12.291v4.079h-4.023v12.346Z",
    transform: "translate(-14353.293 15709.962)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4221",
    "data-name": "Path 4221",
    d: "M651.4,153.9h4.189v10.472a2.178,2.178,0,0,0,2.26,2.15,2.213,2.213,0,0,0,2.26-2.15V153.9h4.134v10.2a6.422,6.422,0,1,1-12.842,0V153.9",
    transform: "translate(-14368.329 15709.962)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4222",
    "data-name": "Path 4222",
    d: "M689.1,170.055V153.3c.661.606,8.157,7.33,8.984,8.047v-7.716h4.134v16.755c-.827-.717-8.267-7.385-8.984-8.047v7.716H689.1",
    transform: "translate(-14385.25 15710.231)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4223",
    "data-name": "Path 4223",
    d: "M730.792,160.018c-.11.276-1.157,3.307-1.213,3.527h2.48c-.055-.22-1.157-3.252-1.268-3.527m-3.527,10.307H722.8c.11-.331,5.787-16.094,5.9-16.424H733c.11.276,6.008,16.039,6.173,16.424H734.65c-.11-.331-.937-2.48-.992-2.756h-5.4c-.11.22-.937,2.535-.992,2.756",
    transform: "translate(-14400.377 15709.962)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4224",
    "data-name": "Path 4224",
    d: "M558.417,161.608a8.708,8.708,0,1,1-8.708-8.708,8.727,8.727,0,0,1,8.708,8.708",
    transform: "translate(-14318.776 15710.411)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4225",
    "data-name": "Path 4225",
    d: "M558.417,161.608a8.708,8.708,0,1,0-8.708,8.708,8.727,8.727,0,0,0,8.708-8.708m-4.134.055a4.519,4.519,0,1,1-4.519-4.519,4.54,4.54,0,0,1,4.519,4.519",
    transform: "translate(-14318.776 15710.411)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFortunaSimple);
export default __webpack_public_path__ + "static/media/logo_fortuna_simple.b3fa9931ffdf6b4cc957b06c276d0d04.svg";
export { ForwardRef as ReactComponent };